import { useState } from "react";
import ContentAggregator from "../../../applicationUI/aggregator/ContentAggregator.js";
import styled from "styled-components";
import SentCertificateAggregator from "../../../applicationUI/aggregator/SentCertificateAggregator.js";
import ReceivedCertificateAggregator from "../../../applicationUI/aggregator/ReceivedCertificateAggregator.js";
import AnimatedPillTabs from "../../loggedOut/landingPage/loggedOutHomeForApp/AnimatedPillTabs.js";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 900px;
  margin-top: 50px;

  @media (max-width: 900px) {
    width: 100%;
    margin: 0;
  }
`;

export default function ProfilePageFeed({ user }) {
  const [type, setType] = useState(0);

  let typeOptions = [{ value: "CONTENT", label: "Posts" }];

  if (user.accountType == "NGO") {
    typeOptions.push({
      value: "SENT_CERTIFICATES",
      label: "Certificates Issued",
    });
  } else {
    typeOptions.push({
      value: "RECEIVED_CERTIFICATES",
      label: "Certificates Received",
    });
  }

  let activeTab = typeOptions[type].value;

  return (
    <Container>
      <AnimatedPillTabs
        setActiveIndex={setType}
        activeIndex={type}
        tabs={typeOptions}
      />

      {getComponent()}
    </Container>
  );

  function getComponent() {
    if (activeTab == "CONTENT")
      return (
        <ContentAggregator
          hideTitleSection={true}
          userId={user._id}
          columns={2}
        />
      );
    if (activeTab == "RECEIVED_CERTIFICATES")
      return (
        <ReceivedCertificateAggregator
          hideTitleSection={true}
          userId={user._id}
          columns={1}
        />
      );
    if (activeTab == "SENT_CERTIFICATES")
      return (
        <SentCertificateAggregator
          hideTitleSection={true}
          userId={user._id}
          columns={1}
        />
      );
  }
}
